export enum ApplicationAccountType {
  personal = 'PERSONAL',
  business = 'BUSINESS',
}

export interface ApplicationAccountTypeState {
  accountType: ApplicationAccountType;
}
